import { canonTag } from '@battleops/shared';

/** A tag's page (pages/Tag.jsx). The page reads the tag through the suite list, so any spelling lands on one page. */
export const tagPath = (t) => `/tag/${encodeURIComponent(canonTag(t) || String(t || ''))}`;
